module.exports = __webpack_public_path__ + "static/media/temp.eec6d40e.jpg";